import * as PIXI from 'pixi.js-legacy';
import Item from '../Item';

export default class Legs extends Item {
  draw() {
    const { item, ratio } = this;
    const { faceSize, scaledVertices } = this.data;

    this.visible = !item.hidden;

    const isPads = this.item.modelid.indexOf('pads') > -1;
    const baseResourceName = isPads
      ? this.item.id
      : this.item.modelid.substring(this.item.modelid.indexOf('legs'));

    const textures = {
      front:
        PIXI.Loader.shared.resources[
          `${baseResourceName}${isPads ? '' : '_front'}`
        ].texture,
      back: PIXI.Loader.shared.resources[
        `${baseResourceName}${isPads ? '' : '_back'}`
      ].texture,
    };

    // Front pads/legs are connected ~2.5mm inwards from frame...
    const frontLegsOffset = 2.5;
    // ...and so are back pads, while back castors are expanding ~2.5mm outwards
    const backLegsOffset = isPads ? 2.5 : -2.5;

    // Front legs are slightly shorter than castors/model
    const backTextureRatio = faceSize.height / textures.back.height;
    const frontHeight = isPads
      ? faceSize.height
      : backTextureRatio * textures.front.height;

    this.dropAreas = this.dropAreas || new PIXI.Container();
    this.dropAreas.x = 0;

    if (!this.dropAreas.parent) {
      this.addChild(this.dropAreas);
    }

    this.back = this.back || new PIXI.Sprite();
    this.back.texture = textures.back;
    this.back.height = faceSize.height * ratio;
    this.back.width = (faceSize.width - backLegsOffset * 2) * ratio;
    this.back.x = scaledVertices[4][0] + backLegsOffset * ratio;

    // Can't explain this, but it looks a lot better than without it ¯\_(ツ)_/¯
    this.back.y = isPads ? 5 * ratio : 0;

    if (!this.back.parent) {
      this.addChild(this.back);
    }

    this.front = this.front || new PIXI.Sprite();
    this.front.texture = textures.front;
    this.front.height = frontHeight * ratio;
    this.front.width = (faceSize.width - frontLegsOffset * 2) * ratio;
    this.front.x = frontLegsOffset * ratio;
    this.front.y =
      scaledVertices[3][1] - (faceSize.height - frontHeight) * ratio;

    if (!this.front.parent) {
      this.addChild(this.front);
    }

    this.drawChildren();
  }

  setHitArea() {
    this.hitArea = new PIXI.Polygon([]);
  }
}
